import React, { useState, useEffect } from 'react';
import { Progress, Space } from 'antd';
import './Progress.css';
import Number from '../Number/Number';

const progress = (props) => {

    const [initData, setInitData] = useState({
        actual: 0,
        expected: 0,
        percent: 0,
        isOverdue: false
    });
    const [data, setData] = useState({});

    useEffect(() => {

        let tData = { ...initData };

        let tActual = 0;
        let tExpected = 0;
        let tSymbol = "";

        if (props.actual) {
            tActual = parseFloat(props.actual.toString().replaceAll(',', ''));
        }

        if (props.expected) {
            tExpected = parseFloat(props.expected.toString().replaceAll(',', ''));
        }

        if (props.symbol) {
            tSymbol = props.symbol;
        }

        let tPercent = parseFloat(((tActual * 100) / tExpected).toFixed(2));
        let tIsOverdue = false;

        if (tExpected < tActual) {
            tIsOverdue = true;
        }

        tData.actual = tActual;
        tData.expected = tExpected;
        tData.percent = tPercent;
        tData.isOverdue = tIsOverdue;
        tData.symbol = tSymbol;

        setData(tData);
    }, [props.actual, props.expected]);

    return <div>
        <Progress
            className='ProgressBar'
            percent={data.percent}
            format={() => {
                return (
                    <Space size={3}>
                        <Number value={data.actual} />/<Number value={data.expected} symbol={data.symbol} />
                    </Space>
                );
            }}
            status={data.isOverdue ? 'exception' : null}
        ></Progress>
    </div>;
}
export default progress;